import { createDecorator } from 'vue-class-component';
import { mapActions, mapGetters } from 'vuex';

export const NoCache = createDecorator((options: any, key) => {
  // component options should be passed to the callback
  // and update for the options object affect the component
  options.computed[key].cache = false;
});


// TODO: add examples for use
/**
 * @summary Wrapper for vuex mapGetters for class component.
 *
 * @type function
 * @param {string[]} states
 * @param {string} namespace
 */
export function MapGetters(states: string[], namespace?: string) {
  if (states.constructor !== Array) {
    console.error('First parameter must by array');
  }
  return createDecorator((options: any) => {
    if (!options.computed) {
      options.computed = {};
    }
    if (namespace) {
      Object.assign(options.computed, mapGetters(namespace, states));
    }
    if (!namespace) {
      Object.assign(options.computed, mapGetters(states));
    }
  });
}

/**
 * @summary Wrapper for vuex mapActions for class component.
 *
 * @type function
 * @param {string[]} states
 * @param {string} namespace
 */
export function MapActions(states: string[], namespace?: string) {
  if (states.constructor !== Array) {
    console.error('First parameter must by array');
  }
  return createDecorator((options: any) => {
    if (!options.methods) {
      options.methods = {};
    }
    if (namespace) {
      Object.assign(options.methods, mapActions(namespace, states));
    }
    if (!namespace) {
      Object.assign(options.methods, mapActions(states));
    }
  });
}
